import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Contact } from '../models/conflict-result';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IdVerificationResponse } from '../models/id-verification-response';

@Injectable({
    providedIn: 'root'
})
export class IdVerificationService {

    constructor(private dataService: DataService) { }

    searchContact(matterNo: number): Observable<Contact[]> {
        var actionstepOrgKey = sessionStorage.getItem(environment.ACTIONSTEP_ORG_KEY);
        return this.dataService.get<Contact[]>(`api/IdVerification/search?matterNo=${matterNo}&orgKey=${actionstepOrgKey}`);
    }

    runStrategy(contact: Contact[]) {
        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
        var baseUrl = sessionStorage.getItem(environment.API_ENDPOINT);
        var matterNo = sessionStorage.getItem(environment.MATTER_NO);
        var orgKey = sessionStorage.getItem(environment.ORG_KEY);
        var actionstepOrgKey = sessionStorage.getItem(environment.ACTIONSTEP_ORG_KEY);
        return this.dataService.post<IdVerificationResponse>(`api/IdVerification/run-strategy?orgKey=${actionstepOrgKey}&accessToken=${accessToken}&baseUrl=${baseUrl}&matterNo=${matterNo}`, contact);
    }
}
